module.exports = __webpack_public_path__ + "img/ticket3.a5a59e15.svg";